/**
 * defa.views.PhoneNumberDeleteForm
 * A card for deleting PhoneNumbers
 * @version 1.2.0
 */
import Form     from 'scripts/poppet/form';
import template from 'templates/phoneNumberDeleteForm.jst.html';

const PhoneNumberDeleteForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	templateContext: function () {
		return {
			numberName: this.model.numberName(),
		};
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Attempts to save the information to the Model.
	 * @void
	 */
	submit: function () {
		this.model.destroy();
	},
	
} );


export default PhoneNumberDeleteForm;